import { format } from 'date-fns';
import { WarrantyChangeLogEntry } from '../../Models/WarrantyChangeLog';

export default function WarrantyChangeLogPanel({
  entries,
}: {
  entries: WarrantyChangeLogEntry[];
}) {
  if (entries.length === 0) {
    return (
      <p className="text-sm text-gray-600 px-5 pb-4">
        No change history recorded yet.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto px-5 pb-4">
      <table className="w-full text-sm text-left text-gray-700">
        <thead className="bg-gray-100 text-gray-900 uppercase text-xs">
          <tr>
            <th className="px-3 py-2">When</th>
            <th className="px-3 py-2">Who</th>
            <th className="px-3 py-2">Action</th>
            <th className="px-3 py-2">Item</th>
            <th className="px-3 py-2">Field</th>
            <th className="px-3 py-2">From</th>
            <th className="px-3 py-2">To</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((row) => (
            <tr key={row.id} className="border-t border-gray-200">
              <td className="px-3 py-2 whitespace-nowrap">
                {format(new Date(row.changedUtc), 'MMM d, yyyy h:mm a')}
              </td>
              <td className="px-3 py-2">{row.changedByName || '—'}</td>
              <td className="px-3 py-2">{row.action}</td>
              <td className="px-3 py-2">
                {row.entityType}
                {row.entityId ? ` #${row.entityId}` : ''}
              </td>
              <td className="px-3 py-2">{row.fieldName || '—'}</td>
              <td className="px-3 py-2 max-w-[12rem] truncate" title={row.oldValue ?? ''}>
                {row.oldValue ?? '—'}
              </td>
              <td className="px-3 py-2 max-w-[12rem] truncate" title={row.newValue ?? ''}>
                {row.newValue ?? '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
